import { GridFilterModel, GridSortModel } from "@mui/x-data-grid-pro";
import {
  buildCombinedFilter as buildCombinedFilterBase,
  buildOrderBy as buildOrderByBase,
  buildGridifyFilter,
} from "shared/utils/gridify";

const PROGRAM_SEARCH_FIELDS = ["programName", "machineType", "modifiedBy"];

export const buildCombinedFilter = (
  searchText: string,
  gridFilters: GridFilterModel,
): string => {
  return buildCombinedFilterBase(
    searchText,
    gridFilters,
    PROGRAM_SEARCH_FIELDS,
  );
};

export const buildOrderBy = (sortModel: GridSortModel): string | undefined => {
  const mappedSortModel = sortModel.map((item) => ({
    ...item,
    field: item.field === "modifiedAt" ? "periodStart" : item.field,
  }));

  return buildOrderByBase(mappedSortModel);
};

export { buildGridifyFilter };
